import { CheckPrimary as CheckPrimaryIcon } from '@ahamove/icons/order';

import type { SpecialRequest } from '@ahm/api-wrappers-core';
import { formatCurrency } from '@ahm/common-helpers';
import { ActionIcon, rem, Text } from '@mantine/core';
import React from 'react';
import AddRequestPrimaryIcon from '@/assets/icons/add-request-primary-bg.svg';
import AddRequestIcon from '@/assets/icons/add-request.svg';
import MinusRequestDisabledIcon from '@/assets/icons/minus-request-disabled.svg';
import MinusRequestPrimaryIcon from '@/assets/icons/minus-request-primary-bg.svg';

const PriceDisplay = ({
  price,
  isMobile,
}: {
  price: number;
  isMobile: boolean;
}) => {
  return (
    <Text
      mx={rem(8)}
      miw={20}
      size={isMobile ? 'xs' : 'sm'}
      ta="center"
      c="neutral.6"
    >
      {formatCurrency(price)}
    </Text>
  );
};

const ActionButton = ({
  onClick,
  icon: Icon,
  disabled = false,
}: {
  isMobile: boolean;
  onClick: (e: React.MouseEvent) => void;
  icon: React.ElementType;
  disabled?: boolean;
}) => (
  <ActionIcon
    onClick={onClick}
    size={32}
    bg="transparent"
    c="primary"
    variant="transparent"
    disabled={disabled}
  >
    <Icon className="size-7 md:size-8" viewBox="0 0 32 32" />
  </ActionIcon>
);

export const handleBooleanRequestType = (
  isMobile: boolean,
  request: SpecialRequest,
  param: any,
  handleClickAction: (e: React.MouseEvent, id: string, param?: any) => void
) => {
  const isD2D = request.name === 'Door-to-door' || request.group_id === 'D2D';
  const basePrice = Number(request?.price);

  const currentPrice =
    isD2D && Array.isArray(param) && param?.length > 0
      ? basePrice * param.length
      : basePrice;

  return (
    <>
      <PriceDisplay price={currentPrice} isMobile={isMobile} />
      <ActionButton
        isMobile={isMobile}
        onClick={(e) =>
          handleClickAction(e, request._id, param ? undefined : true)
        }
        icon={param ? CheckPrimaryIcon : AddRequestIcon}
      />
    </>
  );
};
export const handleLoadingGoodsAction = (
  isMobile: boolean,
  request: SpecialRequest,
  param: any,
  estimatedFee: number,
  handleClickAction: (
    e: React.MouseEvent,
    id: string,
    value: any,
    param?: number
  ) => void
) => {
  return (
    <>
      <PriceDisplay price={estimatedFee} isMobile={isMobile} />
      <ActionButton
        isMobile={isMobile}
        onClick={(e) =>
          handleClickAction(e, request._id, param ? undefined : true)
        }
        icon={estimatedFee ? CheckPrimaryIcon : AddRequestIcon}
      />
    </>
  );
};

export const handleCommissionDistancePercentageRequestType = (
  isMobile: boolean,
  request: SpecialRequest,
  param: any,
  estimatedFee: number,
  handleClickAction: (
    e: React.MouseEvent,
    id: string,
    value: any,
    param?: number
  ) => void
) => {
  return (
    <>
      <PriceDisplay price={estimatedFee} isMobile={isMobile} />
      <ActionButton
        isMobile={isMobile}
        onClick={(e) =>
          handleClickAction(e, request._id, param ? undefined : true)
        }
        icon={param ? CheckPrimaryIcon : AddRequestIcon}
      />
    </>
  );
};

export const handlePerUnitRequestType = (
  isMobile: boolean,
  request: SpecialRequest,
  param: number,
  handleClickAction: (
    e: React.MouseEvent,
    id: string,
    value: any,
    param?: number
  ) => void
) => {
  const handleIncrement = (e: React.MouseEvent) => {
    if (param < Number(request?.max_input)) {
      handleClickAction(e, request._id, Number(param + 1));
    }
  };

  const handleDecrement = (e: React.MouseEvent) => {
    handleClickAction(e, request._id, Number(param - 1), param);
  };

  return (
    <>
      {param ? (
        <>
          <ActionButton
            isMobile={isMobile}
            onClick={handleDecrement}
            icon={MinusRequestPrimaryIcon}
          />
          <PriceDisplay
            price={Number(param) * Number(request?.price)}
            isMobile={isMobile}
          />
          <ActionButton
            isMobile={isMobile}
            onClick={handleIncrement}
            icon={
              param >= Number(request?.max_input)
                ? MinusRequestDisabledIcon
                : AddRequestPrimaryIcon
            }
            disabled={param >= Number(request?.max_input)}
          />
        </>
      ) : (
        <>
          <PriceDisplay price={Number(request?.price)} isMobile={isMobile} />
          <ActionButton
            isMobile={isMobile}
            onClick={handleIncrement}
            icon={AddRequestIcon}
          />
        </>
      )}
    </>
  );
};
